import React, {useEffect, useState, useRef} from 'react';
import HRLineDashed from "../assets/hrline-dashed.svg";
import TryonLabsLogo from "../assets/TryOnLabsLogo1.png";
import closeIcon from "../assets/close_icon1.png";
import MailIcon from "../assets/mail_icon.svg";
import {useNavigate} from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import {selectUserData} from "../selectors";
import { useSelector } from "react-redux";
import DiscordIcon from "../assets/discordicon.svg";
import GitHubIcon from "../assets/githubicon.svg";
import { 
    MdOutlineCollections,
    MdOutlineCheckroom,
    MdOutlineFace,
    MdOutlineAutoFixHigh,
    MdOutlineAddPhotoAlternate,
    MdOutlinePhotoCamera,
    MdOutlineStar,
    MdOutlinePerson,
    MdOutlineMenuBook,
    MdOutlineDashboard,
    MdOutlineGroup,
    MdOutlineScience,
    MdOutlineAssignment,
    MdOutlineEmail,
    MdOutlineCode,
    MdOutlineForum
} from 'react-icons/md';
import { PiMagicWand, PiImage, PiCoatHanger, PiBrain, PiFlipHorizontal, PiCreditCard,
    PiUserCircle, 
    PiNotebook
 } from "react-icons/pi";
 import { IoPricetagsOutline } from "react-icons/io5";

const Sidebar = React.forwardRef((props, ref) => {
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();
    const [options, setOptions] = React.useState({
        "/myimages": { text: "My Images", icon: PiImage },
        "/tryonai": { text: "Virtual Try-On", icon: PiCoatHanger },
        "/aimodel": { text: "Model Generation", icon: MdOutlineFace },
        "/reimagineai": { text: "Reimagine", icon: PiMagicWand },
        "/generate": { text: "Generate", icon: PiBrain },
        "/tryonstudio": { text: "Studio", icon: PiFlipHorizontal },
        "/credits": { text: "Credits", icon: PiCreditCard },
        "/profile": { text: "Profile", icon: PiUserCircle },
        "/pricing": { text: "Pricing", icon: IoPricetagsOutline },
        "/docs": { text: "Documentation", icon: PiNotebook },
        "/admin/dashboard": { text: "Dashboard", icon: MdOutlineDashboard },
        "/admin/useronboardingdetails": { text: "User Onboarding Details", icon: MdOutlineAssignment },
        "/admin/users": { text: "Users", icon: MdOutlineGroup },
        "/admin/experiments": { text: "Experiments", icon: MdOutlineScience }
    });

    let adminOptions = [
        "/admin/dashboard",
        "/admin/useronboardingdetails",
        "/admin/users",
        "/admin/experiments"
    ]
    const location = useLocation();
    const sidebarRef = useRef(null);
    const isMobile1 = useMediaQuery({ query: `(max-width: 760px)` })
    const userData = JSON.parse(useSelector(selectUserData));

    useEffect(() => {
        console.log("props.options", props.options.isAdmin, userData)

        const handleResize = () => {
            console.log("innerWidth", window.innerWidth)
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                console.log("is mobile:", isMobile1)

                if(isMobile1){
                    props.closeSideBar();
                }
            }
          };

        window.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('mousedown', handleClickOutside)
        };
    }, []);

    function handleSelectOption(option) {
        console.log("handleSelectOption inside sidebar: ", option)
        if (props.isSidebarOpen && isMobile) {
            props.closeSideBar();
        }
        let options1 = props.options;
        console.log("options1 before", options1)
        Object.keys(options1).forEach((key) => {
            if (key === option) {
                options1[key] = true;
            } else {
                options1[key] = false;
            }
        })
        console.log("options1 after", options1)
        props.handleOptionSelect(option, options1);
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return (
        <div ref={ref}>
            {
                props.isSidebarOpen &&
                (<div className='relative lg:translate-x-0 lg:static lg:w-auto'>

                    <aside id="sidebar-multi-level-sidebar"
                           className="fixed top-0 left-0 z-40 w-64 h-screen transition-transform translate-x-0 bg-white shadow backdrop-blur-[30px] flex flex-col"
                           aria-label="Sidebar">

                        {/* Static Logo Section */}
                        <div className="flex-shrink-0 px-3 py-4">
                            <div
                                className='flex flex-col items-center justify-center w-full cursor-pointer pointer-events-auto'
                                onClick={() => handleSelectOption("/")}>
                                <div className="flex items-center gap-4 px-3 py-2.5 rounded-lg hover:bg-gray-50 transition-colors duration-200">
                                    <img 
                                        src={TryonLabsLogo} 
                                        alt="tryonlabs logo" 
                                        className="w-12 h-12 rounded-lg object-contain"
                                    />
                                    <div className="flex flex-col">
                                        <div className="text-gray-500 text-base font-semibold">
                                            TryOn AI
                                        </div>
                                        <div className="text-gray-900 text-xl font-medium">
                                            Playground
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Scrollable Options Section */}
                        <div className="flex-1 overflow-y-auto px-3">
                            {props.options ? (
                                <div className="space-y-2 font-medium">
                                    {Object.keys(props.options).map((option, key) => (
                                        <div key={key}>
                                            {option.includes("/admin")? userData?.is_staff ? (
                                                <div>   
                                                    <li className={`w-full py-3 px-4 justify-start items-center gap-2.5 inline-flex cursor-pointer ${props.options[option] ? "bg-gradient-to-r from-red-500 to-rose-600 rounded-lg" : ""}`}
                                                    onClick={() => {
                                                        handleSelectOption(option)
                                                    }}>
                                                    <a href="#"
                                                    className={`flex items-center gap-2 ${props.options[option] ? "text-rose-100" : "text-neutral-800 leading-normal"}`}>
                                                        {React.createElement(options[option].icon, { className: "w-5 h-5" })}
                                                        <span className="ms-3">{options[option].text}</span>
                                                    </a>
                                                    </li>
                                                    <img src={HRLineDashed} className="mx-auto" alt="hr line"/>
                                                </div>):(<></>):(<div>   
                                                <li className={`w-full py-3 px-4 justify-start items-center gap-2.5 inline-flex cursor-pointer ${props.options[option] ? "bg-gradient-to-r from-red-500 to-rose-600 rounded-lg" : ""}`}
                                                onClick={() => {
                                                    handleSelectOption(option)
                                                }}>
                                                <a href="#"
                                                className={`flex items-center gap-2 ${props.options[option] ? "text-rose-100" : "text-neutral-800 leading-normal"}`}>
                                                    {React.createElement(options[option].icon, { className: "w-5 h-5" })}
                                                    <span className="ms-3">{options[option].text}</span>
                                                </a>
                                                </li>
                                                <img src={HRLineDashed} className="mx-auto" alt="hr line"/>
                                            </div>)}
                                        </div>
                                    ))}
                                </div>) : (<></>)}
                        </div>

                        {/* Static Social Links Section */}
                        <div className="flex-shrink-0 px-3 pb-4">
                            <div className="text-black bg-gray-50 rounded-xl p-4 border border-gray-100">
                                <div className="space-y-3">
                                    <div className="flex justify-start items-center gap-3 p-2 rounded-lg hover:bg-white transition-all duration-200 cursor-pointer group" onClick={() => window.open("https://github.com/tryonlabs", "_blank")}>
                                        <MdOutlineCode className="w-5 h-5 text-gray-600 group-hover:text-primary transition-colors duration-200"/>
                                        <span className="text-sm font-medium text-gray-600 group-hover:text-primary transition-colors duration-200">Visit GitHub</span>
                                    </div>

                                    <div className="flex justify-start items-center gap-3 p-2 rounded-lg hover:bg-white transition-all duration-200 cursor-pointer group" onClick={() => window.open("https://discord.gg/SuM5Xr9nn9", "_blank")}>
                                        <MdOutlineForum className="w-5 h-5 text-gray-600 group-hover:text-primary transition-colors duration-200"/>
                                        <span className="text-sm font-medium text-gray-600 group-hover:text-primary transition-colors duration-200">Join Discord</span>
                                    </div>

                                    <div className="flex justify-start items-center gap-3 p-2 rounded-lg hover:bg-white transition-all duration-200 cursor-pointer group" onClick={() => window.open("mailto:contact@tryonlabs.ai", "_blank")}>
                                        <MdOutlineEmail className="w-5 h-5 text-gray-600 group-hover:text-primary transition-colors duration-200"/>
                                        <span className="text-sm font-medium text-gray-600 group-hover:text-primary transition-colors duration-200">Contact Us</span>
                                    </div>
                                </div>
                                
                                <div className="mt-4 pt-3 border-t border-gray-100">
                                    <a href="mailto:contact@tryonlabs.ai" className="text-sm text-gray-600 hover:text-primary transition-colors duration-200 flex items-center gap-2">
                                        <span className="w-1.5 h-1.5 rounded-full bg-primary"></span>
                                        contact@tryonlabs.ai
                                    </a>
                                </div>
                            </div>
                        </div>
                    </aside>

                    <div onClick={() => props.closeSideBar()} className='w-8 h-8 fixed left-56 top-4 z-40 lg:hidden m-2 cursor-pointer border rounded-full flex justify-center items-center bg-white'>
                        <img src={closeIcon}/>
                    </div>
                </div>)
            }
        </div>
    )
})

export default Sidebar;
